import styled from "styled-components";

export const BlogCardContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(
    ${({ columns }) => columns},
    minmax(300px, 1fr)
  );
  align-items: stretch;
  width: 100%;
  gap: 16px;
  grid-auto-rows: 1fr;
`;

export const BlogListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const PaginationWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 16px;
`;

export const Link = styled.a`
  all: unset;
  cursor: pointer;
  display: block;
  height: 100%;

  & > div:first-of-type {
    height: 100%;
    box-sizing: border-box;
  }
`;
